import { Tooltip, Text, ActionIcon } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

export const RemainingFacesTooltip = ({
  onConfirmFaces,
}: {
  onConfirmFaces: (hasRemainingFaces: boolean) => void;
}) => (
  <Tooltip
    label={
      <div
        style={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Text size="xs" style={{ color: "white", textAlign: "center" }}>
          Any remaining faces?
        </Text>
        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
          <ActionIcon
            size="sm"
            variant="subtle"
            color="green"
            onClick={() => {
              onConfirmFaces(true);
            }}
            style={{
              backgroundColor: "rgba(34, 197, 94, 0.2)",
              cursor: "pointer",
              pointerEvents: "auto",
            }}
          >
            <IconCheck size={12} />
          </ActionIcon>
          <ActionIcon
            size="sm"
            variant="subtle"
            color="red"
            onClick={() => {
              onConfirmFaces(false);
            }}
            style={{
              backgroundColor: "rgba(239, 68, 68, 0.2)",
              cursor: "pointer",
              pointerEvents: "auto",
            }}
          >
            <IconX size={12} />
          </ActionIcon>
        </div>
      </div>
    }
    opened={true}
    position="top"
    withArrow
    styles={{
      tooltip: {
        backgroundColor: "#333",
        border: "none",
        pointerEvents: "none",
        zIndex: 1000,
      },
    }}
  >
    <div style={{ width: "100%", height: "100%" }} />
  </Tooltip>
);
